import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { toast } from "react-toastify";

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';

//import { AuthContext } from '../../shared/context/auth-context';
import './SharedFileItem.css';
import './GetSharedFileItem.css';

const getFileMeta = mime => {
    // Images handled separately
    if (mime === 'application/pdf') {
        return { icon: '📕', bg: '#e53935', label: 'PDF' };
    }

    if (mime.includes('word')) {
        return { icon: '📘', bg: '#1e88e5', label: 'DOC' };
    }

    if (mime.includes('excel')) {
        return { icon: '📗', bg: '#2e7d32', label: 'XLS' };
    }

    if (mime.startsWith('audio/')) {
        return { icon: '🎵', bg: '#8e24aa', label: 'AUDIO' };
    }

    if (mime.startsWith('video/')) {
        return { icon: '🎬', bg: '#5e35b1', label: 'VIDEO' };
    }

    if (mime === 'text/plain') {
        return { icon: '📄', bg: '#616161', label: 'TXT' };
    }

    return { icon: '📁', bg: '#757575', label: 'FILE' };
};

const GetSharedFileItem = props => {
    //const sharedToken = localStorage.getItem('sharedToken');
    const [sharedToken, setSharedToken] = useState(() =>
        localStorage.getItem('sharedToken')
    );

    const { isLoading, error, clearError } = useHttpClient();
    //const auth = useContext(AuthContext);
    const [showMenu, setShowMenu] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (!sharedToken) {
            history.replace('/entercode');
        }
    }, [sharedToken, history]);

    useEffect(() => {
        const unlisten = history.listen((location) => {
            // If user navigates away from shared page
            if (!location.pathname.startsWith('/shared')) {
                localStorage.removeItem('sharedToken');
                setSharedToken(null); //  THIS is the missing link
            }
        });

        return () => {
            unlisten();
        };
    }, [history]);


    useEffect(() => {
        const handleUnload = () => {
            localStorage.removeItem('sharedToken');
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);


    const downloadFileHandler = async () => {
        try {
            //const fileId = `${props.id}`
            const response = await fetch(
                //`http://localhost:5000/api/files/${props.id}`,
                process.env.REACT_APP_BACKEND_URL + `/files/usershared/${props.id}/download`,
                {
                    method: "GET",
                    headers: {
                        Authorization: 'Bearer ' + sharedToken
                    },
                }

            );

            if (!response.ok) {
                throw new Error("Download failed");
            }

            const blob = await response.blob();

            // extract filename from backend
            const disposition = response.headers.get("Content-Disposition");
            let filename = "download";

            if (disposition && disposition.includes("filename=")) {
                filename = disposition
                    .split("filename=")[1]
                    .replace(/"/g, "");
            }

            // Create a temporary download link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = url;

            a.setAttribute("download", filename);

            document.body.appendChild(a);
            a.click();

            // Cleanup
            a.remove();
            window.URL.revokeObjectURL(url);
            toast.success("File downloaded successfully!");

        } catch (err) {
            console.error("File download error:", err);
            //alert("Unable to download file");
            toast.error(err.message || "Failed to downlaod!");
        }
    };

    const closeSharedAccessHandler = () => {
        localStorage.removeItem('sharedToken');

        setSharedToken(null); // REQUIRED
        history.replace('/entercode');
        // close session logic
        toast.info("Session Closed!");
    };

    const menuRef = useRef();

    // Close menu on outside click and auto-closing on scroll
    useEffect(() => {
        const handleClickOutside = event => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        const handleScroll = () => {
            setShowMenu(false);
        };

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleScroll, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, []);

    const closeMenu = () => setShowMenu(false);

    return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError} />
            <li className="place-item">
                <Card className="place-item__content">
                    {isLoading && <LoadingSpinner asOverlay />}
                    <div className="place-item__image-wrapper" ref={menuRef}>
                        <a
                            /*href={`${process.env.REACT_APP_ASSET_URL}/${props.image}`}*/
                            href={props.image}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="file-card-link"
                        >
                            {props.mimeType.startsWith('image/') ? (
                                <img
                                    /*src={`${process.env.REACT_APP_ASSET_URL}/${props.image}`}*/
                                    src={props.image}
                                    alt={props.originalName}
                                />
                            ) : (
                                <div
                                    className="file-preview file-icon-preview"
                                    style={{ backgroundColor: getFileMeta(props.mimeType).bg }}
                                >
                                    <div className="file-icon">
                                        {getFileMeta(props.mimeType).icon}
                                    </div>
                                    <div className="file-label">
                                        {getFileMeta(props.mimeType).label}
                                    </div>
                                </div>
                            )}
                        </a>
                        <button
                            className="place-item__menu-btn"
                            onClick={e => {
                                e.preventDefault();   // 👈 stop link click
                                e.stopPropagation();
                                setShowMenu(prev => !prev);
                            }}

                        >
                            ⋮
                        </button>

                        {showMenu && (
                            <div className="place-item__menu">

                                {props.creatorId && (
                                    <Button onClick={() => { downloadFileHandler(); closeMenu(); }}>Download</Button>
                                )}

                            </div>
                        )}
                    </div>
                    {/* FILE NAME BELOW CARD */}
                    <p className="file-name-below" >
                        <a
                            /*href={`${process.env.REACT_APP_ASSET_URL}/${props.image}`}*/
                            href={props.image}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {props.originalName}
                        </a>
                    </p>
                </Card>
            </li>

            <div className="shared-footer">
                <Button danger onClick={closeSharedAccessHandler}>
                    CLOSE
                </Button>
            </div>

        </React.Fragment>

    );
};

export default GetSharedFileItem;